{
    "warning": "ADVARSEL!",
    "message": "Ikke skriv inn eller lim inn kode som du ikke forstår.\nHvis du bruker denne konsollen, kan du gi uvedkommende anledning til å etterligne deg og stjele informasjon gjennom såkalte XSS-angrep."
}
